import { createReducer, on } from "@ngrx/store";
import { homeDataModel } from "@sports-models/index";
import { SPORTS_NAVIGATION_SERVICE_ERROR_CODES } from "@sports-services/sports.navigation.service";
import { SPORTS_NAVIGATION_SERVICE_ERROR_LOCATION } from "@sports-services/sports.navigation.service/sports.navigations.constants";
import * as SportsbookActions from "../../../../sports/stores/sportsbook/sportsbook.actions";

export const initialState: homeDataModel = {
  marquee: [],
  homeLiveEvents: {
    LiveEventsCount: 0,
    LiveSport: [],
  },
  highlightsEvents: {
    events: [],
    sports: [],
    selectedSport: null,
  },
  betBuilder: [],
  restartingPolling: false,
};

export const SportsbookHomeReducer = createReducer(
  initialState,
  on(SportsbookActions.setHome, (state, { type, ...homeData }) => ({
    ...state,
    ...homeData,
    restartingPolling: false,
    firstLoadDone: true,
  })),
  on(SportsbookActions.clearHome, (state) => ({
    ...state,
    ...initialState,
    restartingPolling: false,
  })),
  on(SportsbookActions.setSportsError, (state, { type, ...payload }) => {
    if (
      payload.errorCode === SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_POLLING_ERROR &&
      payload.errorDescription.ID === SPORTS_NAVIGATION_SERVICE_ERROR_LOCATION.LOCATION_6.ID
    ) {
      return {
        ...state,
        restartingPolling: true,
      };
    }
    return state;
  }),
  on(SportsbookActions.restartingHomePollingTick, (state, { type, ...payload }) => {
    return {
      ...state,
      tickCounter: payload.counter,
    };
  }),
);
